import { ActionType as AT } from './enums/action-type.enum';

export const updateProgressValue = (current:any) => ({
	type: AT.UPDATE_PROGRESS_VALUE as typeof AT.UPDATE_PROGRESS_VALUE,
	payload: { current }
});

export const toggleProgress = (status:boolean) => ({
	type: AT.TOGGLE_PROGRESS as typeof AT.TOGGLE_PROGRESS,
	payload: { status }
});

export const setError = (error:string) => ({
	type: AT.SET_ERROR as typeof AT.SET_ERROR,
	payload: { error }
});

export const resetError = () => ({
	type: AT.RESET_ERROR as typeof AT.RESET_ERROR
});

export const togglePreloader = (active:boolean, mode:'default' | 'transparent' = 'default') => ({
	type: AT.TOGGLE_PRELOADER as typeof AT.TOGGLE_PRELOADER,
	payload: { active, mode }
});

export const showError = (code:number) => ({
	type:	AT.SHOW_ERROR as typeof AT.SHOW_ERROR,
	payload: { code }
});

export const addPhone = (phone:string) => ({
	type: AT.ADD_PHONE as typeof AT.ADD_PHONE,
	payload: { phone }
});

export const setInitialPageIndex = (index:number) => ({
	type: AT.SET_INITIAL_PAGE_INDEX as typeof AT.SET_INITIAL_PAGE_INDEX,
	payload: { index }
});

export const setQuizWasOpened = (status:boolean) => ({
	type: AT.SET_QUIZ_WAS_OPENED as typeof AT.SET_QUIZ_WAS_OPENED,
	payload: { status }
});